import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=06f623b1&"
import script from "./Header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports